var numberOfItems = 0;

$(document).ready(function(){
	
	$( "#matrix-tabs-multi-prov" ).tabs();

	$('#matrixDep').bxSlider({
		minSlides: 6,
		maxSlides: 6,
		slideWidth: 90,
		slideMargin: 0,
		infiniteLoop: false,
		hideControlOnEnd: true,
		pager:false
	 });
	
	$('#matrixRet').bxSlider({
		minSlides: 6,
		maxSlides: 6,
		slideWidth: 90,
		slideMargin: 0,
		infiniteLoop: false,
		hideControlOnEnd: true,
		pager:false
	 });
	
});




function filterByOperatorName2(operatorName) {
	operatorName = operatorName.replace(/ /g,"");
	
	resetAllFilterInputs();
	$(".departureFlight,.returnFlight").prop("checked",false);
	
	$(".searchFilterAirline").not("#cb" + operatorName).prop("checked",false);
	$(".searchFilterAirline").filter("#cb" + operatorName).prop("checked",true);
	
	searchFilter();
}

function filterByTransferCount2(transferCount) {
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	
	$(".dTransferCount").not("#filterByTransfer" + transferCount).prop("checked",false);
	$(".dTransferCount").filter("#filterByTransfer" + transferCount).prop("checked",true);
	searchFilter();
}

function filterByFlightID2(strID, departure){
	
	openLoaderBox();
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	$(".priceRadio").prop("checked",false);
	
	var $flightTempList = {};
	if(departure){
		$flightTempList = $flightListDep;
	}else{
		$flightTempList = $flightListRet;
	}
	$flightTempList.attr("data-visible","false");
	
	var idList = strID.split(";");
	var idValues;
	
	idValues = idList[0].split("_");
	
	$flightTempList.filter("[flightId='" + idValues[0] + "'][fareIndex='" + idValues[1] + "']").attr("data-visible","true");
	$flightTempList.filter("[flightId='" + idValues[0] + "'][fareIndex='" + idValues[1] + "']").find(".priceRadio").attr("checked", "checked");
	$flightTempList.filter("[flightId='" + idValues[0] + "'][fareIndex='" + idValues[1] + "']").find(".priceRadio").click();
	
	flightOpen2[(departure ? "return" : "departure")] = true;
	
//	pageIndex = 0;
	refreshTable2();
	
	closeLoaderBox();
}

function removeFilter2(){
	openLoaderBox();
	
	resetAllFilterInputs();	
	$(".departureFlight,.returnFlight").prop("checked",false);
	$(".priceRadio").prop("checked",false);
	$flightListDep.attr("data-visible","true");
	$flightListRet.attr("data-visible","true");
	
	flightOpen2["departure"] = true;
	flightOpen2["return"] = true;
	
//	pageIndex = 0;
	refreshTable2();
	closeLoaderBox();
	
}

